import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, LoadingController, NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { BannerService } from 'src/app/services/banner/banner.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { DEPOSIT_PATTERN } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { CashierBase } from '../../cashier-base/cashier-base';

@Component({
  selector: 'app-deposit-playplus',
  templateUrl: './deposit-playplus.component.html',
  styleUrls: ['./deposit-playplus.component.scss'],
})

export class DepositPlayplusComponent extends CashierBase implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() depositMethod: string;
  @Input() public navigateBackPage: any;


  public accounts: Array<any> = [];
  public amount: string;
  public bonusCode: string;
  public defaultAmounts: any = [];
  public error = null;
  public labels: DepositMainLabels;
  public minAmount: any;
  public objectKeys = Object.keys;
  public paymentType: any = [];
  public prepaidMethod;
  public sightLineAmountLimit: any = [];
  public sightLineMax: number;
  public sightLineMin: number;
  public vendorLogoUrl: string = '';
  
  public depositForm: FormGroup;
  public inputAmount: AbstractControl;
  public buttonDisabled: boolean = true;

  public loading: any;

  constructor(
    public accountBalanceService: AccountBalanceService,
    public bannerService: BannerService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public config: ConfigService,
    public depositService: DepositService,
    public events: EventsService,
    public navigator:Navigator,
    public navParams:NavParams,
    public successMessageService: SuccessMessageService,
    public loadingController: LoadingController
  ){
    super();
    this.error = null;
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
    this.prepaidMethod = 'prepaid:enroll';
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Loading...',
      duration: 3000
    });
  
    this.loading.present();
  }

  ngOnInit(): void {
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);

    this.depositForm = new FormGroup({
      inputAmount: new FormControl({value: '', disabled: false}, {validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required], updateOn: 'change'})
    });

    this.inputAmount = this.depositForm.get('inputAmount');

    this.checkPrepaidAccounts();
    this.getPaymentLimits();
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes('SL').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
        this.minAmount = this.paymentType[0].min;
        this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);

      }
    }, (error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });
  }

  ngAfterViewInit(){
    this.cashierContentService.getPageConfig('playplus').then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  public selectedDepositBonusOffer($event): void{
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  public checkPrepaidAccounts() {
    return new Promise((resolve:any, reject:any) => {
        this.depositService.callHasSightlineAccount().subscribe((response: any) => {
                if (response && !!response.payload) {
                    if ('hasAccount' in response.payload) {
                        if (!!response.payload.hasAccount) {
                          this.buttonDisabled = false;
                            this.prepaidMethod = 'prepaid:deposit';
                            resolve(this.prepaidMethod);
                        }
                    }
                }
                resolve();
            },
            (error) => {
              this.error = this.handleError(error);
              this.content.scrollToTop(10);
              reject();
            }
        );
    });
  }

  public onAmountSelected(data) {
    return this.depositForm.get('inputAmount').setValue(data);
  }

  public getPaymentLimits() {
    this.cashierService.getActivePaymentTypes().subscribe((response: any) => {
        if (response.result && response.payload.length > 0) {
            this.sightLineAmountLimit = response.payload.filter(account => account.code === "SL");
            this.sightLineMin = Math.round(this.sightLineAmountLimit[0].min)
            this.sightLineMax = Math.round(this.sightLineAmountLimit[0].max)
            this.inputAmount.setValidators([Validators.required, Validators.pattern('[1-9][0-9]*(\\.[0-9]{1,2})?'),
            Validators.min(this.sightLineMin), Validators.max(this.sightLineMax)]);
        }}, (error) => {
          this.error = this.handleError(error);
          this.content.scrollToTop(10);
          console.error("Siteline Error", error)
      });
  }

  public onPrepaidAction(action): any {
    return this.navigator.navigateTo("DepositPlayplusActionComponent", { multipleModals: true }, { amount: this.amount, bonusCode: this.bonusCode, action: action});
  }

  public onSubmit(): any{
    this.buttonDisabled = true;
    // this.content.scrollToTop(10);
    this.showLoading();
    this.successMessageService.clearMessage();
    this.error = null;

    let prepaidData: any = {};
    prepaidData.amount = this.inputAmount.value;
    prepaidData.bonusCode = this.bonusCode;
    prepaidData.currency_code = this.config.getConfig().DEFAULT_CURRENCY;
    prepaidData.payment_type_code = "SL";

    this.cashierService.callDeposit(prepaidData).subscribe((response: any) => {
      if (response && !!response.result) {
        let paymentRequestID = response.payload.paymentRequestID;
        setTimeout(() => this.depositForm.reset(), 500);
        /*let depositEventData: AffiliateTrackerCallbackParams = {
            customer_id: this.cashierService.customer.customerId,
            amount: this.amount,
            paymentMethod: "UNIBET-PLAY+",
            transaction_id: paymentRequestID
        }

        setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);*/
        setTimeout(() => this.bannerService.fetchAllBanners(), 1000);
        setTimeout(() => this.accountBalanceService.updateBalance(), 1000);
        this.successMessageService.setMessage("Your deposit was successful!");
        this.content.scrollToTop(10);
        
        this.loading.dismiss();
        let exceededDepositLimit = false;
        if ('hasExceededDepositLimit' in response.payload) {
            exceededDepositLimit = response.payload.hasExceededDepositLimit;
        }

        if (exceededDepositLimit) {
          this.navigator.navigateTo('DepositThresholdComponent', {}, { status: true, amount: this.depositForm.get('inputAmount').value, customerId: this.cashierService.customer.customerId});
        } else {
          this.navigator.navigateTo("DepositSuccessFailureComponent", { multipleModals: true }, { status: true, message: this.successMessageService.getMessage() });
        }
        this.buttonDisabled = false;
      }
    }, error => {
      this.buttonDisabled = false;
      this.error = this.handleError(error);
      let failureReason = this.error.error_message;
      this.loading.dismiss();
      this.navigator.navigateTo("DepositSuccessFailureComponent", { multipleModals: true }, { status: false, message: failureReason });
    });
  }

  onBack = () => {
    if(!this.navigateBackPage) return this.navigator.back();
    if(this.navigateBackPage == "default") return this.navigator.navigateTo("DepositMainComponent", { multipleModals: true });
    return this.navigator.navigateTo(this.navigateBackPage);
  }

}
